(function() {
    'use strict';

    angular
        .module('elogbooks.admin.settings')
        .controller('AdminConfigurationSettingsListController', AdminConfigurationSettingsListController);

    function AdminConfigurationSettingsListController($translate, configurationSettingsResponse, configurationCategory) {
        var TRANSLATION_KEYS = {
            assets_module_enabled: 'ASSET_SETTINGS',
            audits_module_enabled: 'AUDITS',
            contracts_module_enabled: 'CONTRACTS',
            surveys_module_enabled: 'SURVEY_SETTINGS',
            waste_management_module_enabled: 'WASTE_MANAGEMENT',
            duty_management_module_enabled: 'DUTY_MANAGEMENT',
            master_tasks_module_enabled: 'MASTER_TASKS',
            tasks_module_enabled: 'TASKS',
            meters_module_enabled: 'METERS',
            spillages_module_enabled: 'SPILLAGES',
            patrols_module_enabled: 'PATROLS',
            late_open_early_close_module_enabled: 'LATE_OPEN_EARLY_CLOSE_MODULE_ENABLED',
            client_admin_user_enabled: 'CLIENT_ADMIN',
            quote_value_approval_enabled: 'QUOTE_VALUE_APPROVAL_ENABLED',
            sharing_enabled: 'SHARING_ENABLED',
            sp_feedback_enabled: 'SP_FEEDBACK_SETTINGS',
            webhook_job: 'WEBHOOK_JOB',
            webhook_quote: 'WEBHOOK_QUOTE',
            quotes_module_enabled: 'QUOTES'
        };

        var vm = this;

        vm.getTranslationKey = getTranslationKey;
        vm.items = (configurationSettingsResponse[configurationCategory] || []).slice().sort(function(a, b) {
            return getSortValue(a).localeCompare(getSortValue(b));
        });

        function getTranslationKey(item) {
            return TRANSLATION_KEYS[item] || item.toUpperCase();
        }

        function getSortValue(item) {
            if (configurationCategory === 'integrations') {
                return String(item).toLowerCase();
            }

            return $translate.instant(getTranslationKey(item)).toLowerCase();
        }
    }
})();
